import { useContext } from 'react'

import { UploadFlowContext, type TUploadPlacement } from './UploadFlowContext'

export const useUploadFlow = () => useContext(UploadFlowContext)

export type { TUploadPlacement }
